import { Navigate, type RouteObject } from 'react-router-dom';
import AssetsPage from '../pages/AssetsPage';
import ModelPage from './pages/ModelPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AssetsPage tab="models" />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <ModelPage />,
      },
    ],
  },
];

export default routes;